
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import {RequestPaging} from "@/utils/util";
import {apiArticleLists, apiArticleDel, apiArticleIsShow, apiShopLists} from '@/api/shop'

@Component({
  components: {
    lsPagination
  },
  filters: {
    formatDate(value: any) {
      if (!value) return '';
      // 将秒级时间戳转换为毫秒级时间戳以正确显示日期
      const date = new Date(value * 1000);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    }
  }
})
export default class ArticleList extends Vue {
  pager: RequestPaging = new RequestPaging();
  searchObj: any = {};
  shopList: any[] = [];

  async getLists(): Promise<void> {
    this.pager.request({
      callback: apiArticleLists,
      params: this.searchObj
    });
  }

  resetSearch(): void {
    this.searchObj = {};
    this.getLists();
  }

  async getShopList(): Promise<void> {
    try {
      const res: any = await apiShopLists({
        page_no: 1,
        page_size: 9999
      });
      this.shopList = res.lists || [];
    } catch (error) {
      console.error('获取商户列表失败:', error);
      this.shopList = [];
    }
  }

  async onDelete(row: any): Promise<void> {
    await apiArticleDel({id: row.id});
    this.getLists();
  }

  async changeStatus(value: number, row: any): Promise<void> {
    try {
      await apiArticleIsShow({id: row.id});
    } catch (e) {
      row.is_show = row.is_show === 1 ? 0 : 1;
    }
  }

  created() {
    this.getShopList();
    this.getLists();
  }
}
